import React, { PureComponent } from 'react';

import { Avatar, Image } from 'components/ClubComponents';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import { DEFAULT_AVATAR } from './constants';

const RETRIABLE = {
  max: 5,
  interval: 3000
};

@translate()
class PersonaAvatar extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    size: PropTypes.number,
    src: PropTypes.string,
    t: PropTypes.func,
    onLoad: PropTypes.func,
    onError: PropTypes.func
  };

  renderPlaceholder() {
    const { placeholder, t } = this.props;

    /**
     * How to keep the same immutable default placeholder and
     * still be able to translate its `alt`?
     */
    return (
      placeholder || {
        borderless: true,
        paddingless: true,
        children: (
          <Image
            src={DEFAULT_AVATAR}
            alt={t(
              'community.configuration.persona.topic_form_fields.avatar_title'
            )}
            variant={Image.VARIANT.ROUNDED}
          />
        )
      }
    );
  }

  render() {
    const { className, disabled, size, src, t, onLoad, onError } = this.props;

    return (
      <Avatar
        className={className}
        disabled={disabled}
        src={src}
        placeholder={this.renderPlaceholder()}
        variant={Avatar.VARIANT.ROUNDED}
        size={size}
        alt={t(
          'community.configuration.persona.topic_form_fields.avatar_title'
        )}
        retriable={RETRIABLE}
        onError={onError}
        onLoad={onLoad}
        fit={Image.FIT.COVER}
      />
    );
  }
}

PersonaAvatar.propTypes = {
  disabled: false,
  size: 152
};

export default PersonaAvatar;
